// src/LoginPage.styles.ts

export const styles = {
  card: {
    width: { xs: '90%', sm: '80%', md: '79%', lg: '79%' },
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    boxShadow: 3,
    py: 2,
  },
  cardContent: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: 0,
  },
  imageBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: { xs: '100%', md: '50%' },
    padding: 2,
    borderRight: { md: '1px solid #e0e0e0' },
    borderBottom: { xs: '1px solid #e0e0e0', md: 'none' },
  },
  header: {
    fontSize: '24px',
    lineHeight: '32px',
    mb: 3,
    mt: 2,
  },
  appTitleLink: {
    color: '#F50057',
  },
  image: {
    width: '275px',
    height: '150px',
  },
  formBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: { xs: '100%', },
    padding: 2,
  },
  formStack: {
    width: '100%',
    p: 3,
  },
  submitButton: {
    mt: 2,
    mx: 3,
    bgcolor: '#ff270b',
    color: 'white',
    '&:hover': {
      bgcolor: '#ff270b',
      color: 'white',
    },
  },
  page: {
    position: "relative",
    minHeight: "100vh",
    bgcolor: "background.default",
  },
  container: {
    position: "relative",
    zIndex: 2,
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    py: 4,
  },
  paper: {
    width: "80%",
    px: { xs: 3, sm: 1 },
    py: { xs: 4, sm: 1 },
    borderRadius: 3,
    backdropFilter: "blur(4px)",
    backgroundColor: "rgba(255,255,255,0.85)",
  },
  logo: {
    display: "inline-block",
    height: "auto",
    maxWidth: "100%",
    width: { xs: 250, sm: 250, md: 300 },
  },
  backgroundRoot: {
    position: "fixed",
    inset: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  backgroundImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
};
